import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { SharesByCompanyType } from "types/SharesTypes";

export default function useGetSharesByCompany(id?: number) {
  return useQuery({
    queryKey: ["shares/company", id],
    queryFn: async () => {
      return axiosInstance.get(`/shares/company/${id}`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: SharesByCompanyType[]) => data,
    retry: false,
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
}
